import { render, staticRenderFns } from "./OrganizationInviteWrapper.vue?vue&type=template&id=3fcdb6d0&"
import script from "./OrganizationInviteWrapper.vue?vue&type=script&lang=js&"
export * from "./OrganizationInviteWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports